(() => {
  const SESSION_KEY = 'gl360Language';
  const params = new URL(window.location.href).searchParams;
  if (params.get('view') === 'english' || params.get('glang') === 'en') {
    sessionStorage.setItem(SESSION_KEY, 'en');
  }
  if (sessionStorage.getItem(SESSION_KEY) !== 'en') return;

  const CJK_TEST = /[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/;
  const CJK_GLOBAL = /[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/g;
  const ENGLISH_SIGNAL = /[A-Za-z]/;
  const PROMO_TITLES = {
    '米水米奶袋套装-rice-water-rice-milk-set-pouch': 'Rice Water & Rice Milk Pouch Set — Buy 4 Get 1 Free',
    '胶原蛋白-蛋白质优惠-collagen-protein': 'Collagen & Protein Set — Buy 4 Get 1 Free',
    '米水米奶优惠-rice-water-rice-milk': 'Rice Water & Rice Milk Set — Buy 5 Get 1 Free',
    '优质汤包优惠-premium-soup-pack': 'Premium Soup Pack Set — Buy 5 Get 1 Free'
  };

  const decodePart = (value = '') => {
    try { return decodeURIComponent(value); } catch (_) { return value; }
  };

  const tidy = (value = '') => value
    .replace(/[，。；：！？、「」『』《》【】]/g, ' ')
    .replace(/[（）]/g, ' ')
    .replace(/[｜|]+/g, ' | ')
    .replace(/\s+([,.;:!?])/g, '$1')
    .replace(/\s*\|\s*$/g, '')
    .replace(/^\s*\|\s*/g, '')
    .replace(/^\s*[—–·:;,-]+\s*/g, '')
    .replace(/\s*[—–·:;,-]+\s*$/g, '')
    .replace(/\s+\/\s*$/g, '')
    .replace(/(\d)\s*\/\s*(?=[A-Za-z])/g, '$1 ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const englishOnlyText = (value = '') => {
    if (!CJK_TEST.test(value)) return value.trim();
    return tidy(value.replace(CJK_GLOBAL, ' '));
  };

  const humanizeSlug = (slug = '') => {
    const clean = tidy(decodePart(slug).replace(CJK_GLOBAL, ' ').replace(/[^A-Za-z0-9]+/g, ' '));
    if (!ENGLISH_SIGNAL.test(clean)) return '';
    return clean.replace(/\b\w/g, (m) => m.toUpperCase());
  };

  const productHandleFromHref = (href = '') => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/^\/products\/([^/?#]+)/);
      return match ? decodePart(match[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const currentProductHandle = () => {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodePart(match[1]) : '';
  };

  const productTitle = (value, handle = '') => {
    if (handle && PROMO_TITLES[handle]) return PROMO_TITLES[handle];
    const cleaned = englishOnlyText(value || '');
    if (ENGLISH_SIGNAL.test(cleaned)) return cleaned;
    const fromHandle = humanizeSlug(handle);
    return fromHandle || cleaned || value || '';
  };

  const textNodes = (root) => {
    if (!root) return [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  };

  const cleanTextNodes = (root, removePureChinese = false) => {
    textNodes(root).forEach((node) => {
      const original = node.nodeValue || '';
      if (!CJK_TEST.test(original)) return;
      const cleaned = englishOnlyText(original);
      if (cleaned && (ENGLISH_SIGNAL.test(cleaned) || /\d/.test(cleaned))) {
        node.nodeValue = cleaned;
      } else if (removePureChinese) {
        node.nodeValue = '';
      }
    });
  };

  const removeEmptyRichTextBlocks = (root) => {
    if (!root) return;
    root.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').forEach((el) => {
      if (!el.textContent.trim() && !el.querySelector('img, video, svg, a[href]')) el.remove();
    });
  };

  const cleanRichText = (root) => {
    if (!root) return;
    cleanTextNodes(root, true);
    removeEmptyRichTextBlocks(root);
  };

  const translateProductAnchor = (anchor) => {
    if (!anchor) return;
    const handle = productHandleFromHref(anchor.getAttribute('href') || '');
    const value = productTitle(anchor.textContent.trim(), handle);
    if (value) anchor.textContent = value;
  };

  const translateProductCards = (root = document) => {
    root.querySelectorAll('.card__heading a[href*="/products/"], .predictive-search__item-heading, .quick-add-modal h3 a[href*="/products/"], .quick-add-modal a.full-unstyled-link[href*="/products/"]').forEach((el) => {
      if (el.matches('a')) translateProductAnchor(el);
      else {
        const anchor = el.closest('a[href*="/products/"]') || el.querySelector('a[href*="/products/"]');
        if (anchor) translateProductAnchor(anchor);
        else {
          const handle = productHandleFromHref(el.closest('[data-product-url]')?.getAttribute('data-product-url') || '');
          const value = productTitle(el.textContent.trim(), handle);
          if (value) el.textContent = value;
        }
      }
    });

    root.querySelectorAll('.cart-item__name[href*="/products/"], a.cart-item__name, .product-item a[href*="/products/"]').forEach(translateProductAnchor);
  };

  const translateVariantPresentation = (root = document) => {
    root.querySelectorAll('variant-selects .product-form__input, .product-form__input select, .product-form__input option, .product-option, .cart-item__details .product-option').forEach((el) => cleanTextNodes(el, false));
  };

  const translateProductPage = () => {
    if (!window.location.pathname.startsWith('/products/')) return;
    const handle = currentProductHandle();
    document.querySelectorAll('.product__title h1, .product__title h2.h1').forEach((el) => {
      const value = productTitle(el.textContent.trim(), handle);
      if (value) el.textContent = value;
    });

    document.querySelectorAll('.product__description.rte').forEach(cleanRichText);
    document.querySelectorAll('.product__accordion .accordion__title').forEach((el) => cleanTextNodes(el, false));
    document.querySelectorAll('.product__accordion .accordion__content').forEach(cleanRichText);
    document.querySelectorAll('.product__text').forEach((el) => cleanTextNodes(el, false));
    translateVariantPresentation(document);

    const cleanedDocumentTitle = productTitle(document.title, handle);
    if (cleanedDocumentTitle) document.title = cleanedDocumentTitle;
    document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach((meta) => {
      const value = productTitle(meta.getAttribute('content') || '', handle);
      if (value) meta.setAttribute('content', value);
    });
  };

  const translateCollectionPage = () => {
    if (!window.location.pathname.startsWith('/collections/')) return;
    document.querySelectorAll('.collection-hero__title, .collection__title .title, h1.title--primary').forEach((el) => {
      const cleaned = englishOnlyText(el.textContent || '');
      if (cleaned && ENGLISH_SIGNAL.test(cleaned)) el.textContent = cleaned;
    });
    const cleanedTitle = englishOnlyText(document.title || '');
    if (cleanedTitle && ENGLISH_SIGNAL.test(cleanedTitle)) document.title = cleanedTitle;
    translateProductCards(document);
  };

  const translateHeaderFooter = () => {
    document.querySelectorAll('header, .shopify-section-group-header-group, footer, .shopify-section-group-footer-group').forEach((root) => cleanTextNodes(root, false));
  };

  const translateGenericCommerceUI = () => {
    translateProductCards(document);
    translateVariantPresentation(document);
    document.querySelectorAll('.facets__form, .facet-filters, .mobile-facets, .pagination-wrapper').forEach((el) => cleanTextNodes(el, false));
  };

  const run = () => {
    document.documentElement.lang = 'en';
    document.documentElement.dataset.gl360Language = 'en';
    if (document.body) document.body.classList.add('gl360-english-mode');
    translateHeaderFooter();
    translateProductPage();
    translateCollectionPage();
    translateGenericCommerceUI();
  };

  let scheduled = false;
  const scheduleRun = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      run();
      const observer = new MutationObserver(scheduleRun);
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    run();
    const observer = new MutationObserver(scheduleRun);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();